import React, { useState, useRef, useEffect } from "react";
import { Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServices";
import ApproveOrRejectRequisitionModalAdmin from "./ApproveOrRejectRequisitionModalAdmin";
import ItemsModal from "./ItemsModal";
import Swal from "sweetalert2";

const AdminPendingApproval = ({ onSuccess }) => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [gridInsideModal2, setGridInsideModal2] = useState(false);
  const [sort, setSort] = useState(40); // Number of items per page
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeUsers, setActiveUsers] = useState([]);
  const [activePage, setActivePag] = useState();
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({})
  const [selectedItem2, setSelectedItem2] = useState({})
  const [loading, setLoading] = useState(false);

  const [requisition, setRequisiton] = useState();
  const [selectedRequisition, setSelectedRequisiton] = useState();
  const [run, setRun] = useState(0);

  useEffect(() => {
    if (selectedStore) {
      setLoading(true); // Start loader before making the request
      const status = "adminSubmit";
      RequestServies.getRequest(selectedStore, status)
        .then((res) => {
          const list = res?.data?.data || [];

          // ✅ FILTER REVISED
          const filteredList = list.filter(item => item.revisionType !== "revised");

          setRequisiton(filteredList);

          if (filteredList.length > 0) {
            setSelectedRequisiton(prev =>
              prev && filteredList.find(r => r._id === prev)
                ? prev
                : filteredList[0]._id
            );
          } else {
            setSelectedRequisiton(null);
            setData([]);
          }

          setLoading(false);
        })
        .catch((error) => {
          setLoading(false); // Stop loader on error
          console.log(error);


        });
    }
  }, [selectedStore]);

  useEffect(() => {
    if (selectedStore && selectedRequisition) {
      setLoading(true);
      RequestServies.getAllItem(selectedRequisition, "approvedByAdmin", selectedStore)
        .then((res) => {
          const filtered = res?.data?.data?.filter(item => item.status === "approvedByAdmin");
          setData(filtered); // ✅ ensure only approvedByAdmin is shown
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
        });
    }
  }, [selectedStore, selectedRequisition, run]);


  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };

  // Pagination setup
  useEffect(() => {
    if (data.length > 0) {
      setActivePag(0); // Reset pagination when data changes
    }
  }, [data]);

  const pagination = Math.ceil(data.length / sort);
  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  const handleModel = (e, item) => {
    console.log(item)
    setSelectedItem(item)
    setGridInsideModal(true)
  }
  const handleApproval = (item, status) => {
    const isRemarkRequired = status === "rejected" || status === "tranfer request";

    Swal.fire({
      title: `Are you sure you want to ${status} this request?`,
      text: `Requisition No: ${item?.requisitionNo?.requisitionNo} / Part No: ${item?.inventory?.masterItem?.partNo}`,
      icon: status === "approved" || status === "local" ? "success" : "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel",
      input: isRemarkRequired ? "textarea" : null,
      inputPlaceholder: "Enter your remarks here...",
      inputValidator: (value) => {
        if (isRemarkRequired && !value) {
          return "Remarks are required!";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const remark = isRemarkRequired ? result.value : "";

        RequestServies.updateItem(item._id, {
          approveQty: item.qtyRequired,
          status,
          adminRemark: remark,
        })
          .then(() => {
            Swal.fire({
              icon: "success",
              title: `Request ${status}`,
              text: `The request has been ${status}.`,
            });
            setRun((prev) => prev + 1);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "An error occurred while processing the request.",
            });
            console.error(error);
          });
      }
    });
  };



  const handleShowInventory = (e, item) => {
    console.log(item)
    setSelectedItem2(item)
    setGridInsideModal2(true)
  }

  return (
    <>
      <ApproveOrRejectRequisitionModalAdmin
        show={gridInsideModal}
        item={selectedItem}
        handleClose={() => setGridInsideModal(false)}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      {gridInsideModal2 && selectedItem2 && (
        <ItemsModal
          show={gridInsideModal2}
          item={selectedItem2}
          handleClose={() => setGridInsideModal2(false)}
        />
      )}

      <div className="row">
        {loading ? ( // Show loader if data is loading
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
            <div className="mt-2">Loading Data...</div>
          </div>
        ) : (
          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-6 col-xxl-6">
                        <label>Select Store</label>
                        <select
                          className="form-select mb-xl-0 mb-3"
                          value={selectedStore}
                          onChange={handleStoreChange}
                        >
                          {stores.map((store) => (
                            <option key={store._id} value={store._id}>
                              {store.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-xl-6 col-xxl-6">
                        <label>Select Requisition Number </label>
                        <select
                          className="form-select mb-xl-0 mb-3"
                          value={selectedRequisition}
                          onChange={handleRequsitionChange}
                        >
                          {requisition && requisition.length > 0 ? (
                            requisition.map((item) => (
                              <option key={item._id} value={item._id}>
                                {item.requisitionNo}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>
                              No records found
                            </option>
                          )}
                        </select>

                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="filter cm-content-box box-primary mt-1">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>Pending
                  Approval{" "}
                  <span className="badge bg-orange ms-2">{data.length}</span>
                </div>
                <div className="tools">
                  <Link
                    to="#"
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <div style={{
                          overflowX: 'auto',
                          overflowY: 'auto',
                          maxHeight: '400px',
                          whiteSpace: 'nowrap'
                        }}>
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="transactions-data"
                          >
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#fff", // White background
                                zIndex: 2,
                              }}
                            >
                              <tr>
                                <th>S.No</th>
                                <th>Requisition No</th>
                                <th>Part No</th>
                                <th>Description</th>
                                <th>Store Remark</th>
                                <th>AuthQty</th>
                                <th>Eligible</th>
                                <th>RequestedQty</th>
                                <th>Request status</th>
                                <th>Edit</th>
                                <th>View Stock</th>
                                <th className="text-center">Generate PO</th>
                                <th className="text-center">Local Purchase</th>
                                <th className="text-center">Send for Transfer</th>
                                <th className="text-center">Rejected</th>



                              </tr>
                            </thead>
                            <tbody>
                              {data.length > 0 ? (
                                data
                                  .slice(
                                    activePag.current * sort,
                                    (activePag.current + 1) * sort
                                  )
                                  .map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        {activePag.current * sort + index + 1}
                                      </td>
                                      <td>{item?.requisitionNo?.requisitionNo}</td>
                                      <td>{item?.inventory?.masterItem?.partNo}</td>
                                      <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
                                      <td>{item?.storeRemark}</td>
                                      <td>{item?.inventory?.qtyAuth}</td>
                                      <td>
                                        {item?.inventory?.qtyAuth -
                                          item?.inventory?.currentStock}
                                      </td>
                                      <td>{item?.qtyRequired}</td>
                                      <td className="text-danger fw-bold">{item?.flag}</td>
                                      <td className="text-center">
                                        <button className="btn btn-primary btn-xs sharp" onClick={(e) => { handleModel(e, item) }}>
                                          <i className="fa fa-pencil"></i>
                                        </button>

                                      </td>
                                      <td className="text-center">
                                        <button
                                          className="btn btn-dark btn-xs sharp"
                                          onClick={(e) => { handleShowInventory(e, item) }}

                                        >
                                          <i className="fas fa-search"></i>
                                        </button>


                                      </td>
                                      <td className="text-center">
                                        <button
                                          className="btn btn-success btn-xs sharp"
                                          onClick={() => handleApproval(item, "approvedBySuperAdmin")}
                                        >
                                          <i className="fa fa-thumbs-up" aria-hidden="true"></i>

                                        </button>
                                      </td>
                                      <td className="text-center">
                                        <button
                                          className="btn btn-primary btn-xs sharp"
                                          onClick={() => handleApproval(item, "local")}
                                        >
                                          <i className="fa fa-thumbs-up" aria-hidden="true"></i>

                                        </button>
                                      </td>
                                      <td className="text-center">
                                        <button
                                          className="btn btn-warning btn-xs sharp ms-2"
                                          onClick={() => handleApproval(item, "tranfer request")}
                                        >
                                          <i className="fa fa-thumbs-down" aria-hidden="true"></i>
                                        </button>
                                      </td>
                                      <td className="text-center">
                                        <button
                                          className="btn btn-danger btn-xs sharp ms-2"
                                          onClick={() => handleApproval(item, "rejected")}
                                        >
                                          <i className="fa fa-thumbs-down" aria-hidden="true"></i>

                                        </button>
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td colSpan="15" className="text-center">
                                    No Active items Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {activePag.current * sort + 1} to{" "}
                            {Math.min(
                              data.length,
                              (activePag.current + 1) * sort
                            )}{" "}
                            of {data.length} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link
                              className="paginate_button previous"
                              to="#"
                              onClick={() =>
                                activePag.current > 0 &&
                                onClick(activePag.current - 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-left"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <span>
                              {Array.from({ length: pagination }, (_, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${activePag.current === i ? "current" : ""
                                    }`}
                                  onClick={() => onClick(i)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className="paginate_button next"
                              to="#"
                              onClick={() =>
                                activePag.current < pagination - 1 &&
                                onClick(activePag.current + 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-right"
                                aria-hidden="true"
                              ></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminPendingApproval;
